import React from "react";
const Footer = () => {
    return (<>
        <div className="Footer">
            <span>Designed by</span> <span id="name">Vineet Jadhav</span>
        </div>
    </>)
}
export default Footer